export default __webpack_public_path__ + "static/media/c010-4.621a0f1c.png";